import React, { Component } from 'react'
import { Button, Table, Loader, Card } from 'semantic-ui-react'
import { connect } from 'react-redux'

import actions from '../redux/actions'
import TranscriptionItem from '../components/TranscriptionItem'

import './HomePage.css'
import { s3Delete } from '../libs/awsLib'

class HomePage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      deleteTranscriptionId: null
    }
  }

  async componentDidMount () {
    this._intervalId = setInterval(() => this.props.loadTranscriptions(), 30000)
    this.props.loadTranscriptions()
  }

  componentWillUnmount () {
    if (this._intervalId) {
      clearInterval(this._intervalId)
    }
  }

  render () {
    return (
      <div className='HomePage'>
        <Card fluid>
          <Table className='HomePage-table' padded unstackable>
            <Table.Header fullWidth>

              <Table.Row>
                <Table.HeaderCell colSpan='1'>
                  <h3>Transcriptions</h3>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan='3'>
                  <Button
                    floated='right'
                    onClick={this.createTranscription}
                    primary
                  >
                    New Transcription
                  </Button>
                </Table.HeaderCell>
              </Table.Row>

              <Table.Row>
                <Table.HeaderCell singleLine>
                  Title
                </Table.HeaderCell>

                <Table.HeaderCell singleLine>
                  Created at
                </Table.HeaderCell>

                <Table.HeaderCell singleLine>
                  Status
                </Table.HeaderCell>

                <Table.HeaderCell />
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.props.isLoading
                ? this.renderLoadingRow()
                : this.renderTranscriptions()}
            </Table.Body>
          </Table>
        </Card>

      </div>
    )
  }

  renderTranscriptions = () => {
    const { transcriptions } = this.props

    if (!transcriptions || !transcriptions.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan={5} textAlign='center'>
            No Transcriptions
          </Table.Cell>
        </Table.Row>
      )
    }

    return transcriptions
      .sort((a, b) => b.createdAt - a.createdAt)
      .map(this.renderRow)
  }

  renderLoadingRow = () => {
    return (
      <Table.Row>
        <Table.Cell colSpan={5} textAlign='center'>
          <Loader active inline size='small' />
        </Table.Cell>
      </Table.Row>
    )
  }

  renderRow = transcription => (
    <TranscriptionItem
      key={transcription.transcriptionId}
      transcription={transcription}
      onSelect={this.goToTranscription}
      onDelete={this.deleteTranscription}
      isDeleting={
        transcription.transcriptionId === this.state.deleteTranscriptionId
      }
    />
  )

  createTranscription = () => {
    this.props.history.push('/app/create')
  }

  goToTranscription = transcription => {
    this.props.history.push(
      `/app/transcriptions/${transcription.transcriptionId}`
    )
  }

  deleteTranscription = async transcription => {
    if (!window.confirm('Really delete this transcription?')) {
      return
    }

    this.setState({ deleteTranscriptionId: transcription.transcriptionId })

    await this.props.deleteTranscription(transcription.transcriptionId)
    s3Delete(transcription.s3Key)

    this.setState({ deleteTranscriptionId: null })
  }
}

const mapStateToProps = state => ({
  transcriptions: Object.values(state.transcriptions.data),
  isLoading: state.transcriptions.isLoading,
  isDeleting: state.transcriptions.isDeleting
})

const mapDispatchToProps = dispatch => ({
  loadTranscriptions: () => dispatch(actions.transcriptions.load()),
  deleteTranscription: transcriptionId =>
    dispatch(actions.transcriptions.del(transcriptionId))
})

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)



// WEBPACK FOOTER //
// ./src/containers/HomePage.js